export default "__VITE_ASSET__65c04e34__"